var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],ref:"mainVideo",staticClass:"video-main",on:{"durationchange":function($event){return _vm.setDuration($event.target.duration)},"timeupdate":function($event){return _vm.changeCurrentTime($event.target.currentTime)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0208156","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/content/video-file.vue
// module id = null
// module chunks = 